<template>
  <div id="QuarantineFilters">
    <v-expansion-panels class="px-5 py-1" accordion>
      <v-expansion-panel class="elevation-1">
        <v-expansion-panel-header color="#f2f2f2" class="px-4">
          <span>Filtrar por</span>
          <template v-slot:actions>
            <v-icon color="black"> mdi-chevron-down </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mt-2 pb-1">
            <v-col cols="12" md="4">
              <v-select
                v-model="stateId"
                label="Estado de Entrega"
                :items="states"
                item-text="name"
                item-value="id"
                @change="fetchCitiesByID"
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="cityId"
                label="Município de Entrega"
                :items="cities"
                item-text="name"
                item-value="id"
                @change="saveCityId"
                :disabled="!stateId"
                :loading="loadingCity"
                clearable
              ></v-select>
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete
                class="auto-complete"
                v-model="transhipmentId"
                label="Transbordo"
                :items="transhipments"
                item-text="name"
                item-value="id"
                @change="fetchTranshipmentDeliverersById"
                clearable
              ></v-autocomplete>
            </v-col>
            <v-col v-show="!this.isTransfer" cols="12" md="4">
              <v-autocomplete
                v-model="trashipmentDelivererId"
                class="auto-complete"
                label="Entregador do Tranbordo"
                :items="trashipmentsDeliverer"
                item-text="name"
                item-value="id"
                @change="saveTranshipmentDelivererId"
                :disabled="!transhipmentId"
                :loading="loadingTranshipmentDeliverer"
                clearable
              >
              </v-autocomplete>
            </v-col>
            <v-col v-show="!this.isTransfer" cols="12" md="4">
              <v-autocomplete
                v-model="courierId"
                :loading="isCouriersLoading"
                class="auto-complete"
                label="Entregador Direto"
                :items="couriers"
                item-text="name"
                item-value="id"
                @change="saveDirectDelivererId"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="4">
              <v-combobox
                v-model="numberCTE"
                :search-input.sync="cteNumberInput"
                append-icon=""
                label="Número CTE"
                hide-selected
                multiple
                chips
                deletable-chips
                @keydown.native="filterInput"
                @change="saveCteNumber"
              ></v-combobox>
            </v-col>
            <v-col cols="12" md="4">
              <v-combobox
                v-model="numberNfe"
                :search-input.sync="nfeNumberInput"
                append-icon=""
                label="Número da Nota Fiscal"
                hide-selected
                multiple
                chips
                deletable-chips
                @keydown.native="filterInput"
                @change="saveNfeNumber"
              ></v-combobox>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="justification"
                label="Justificativa"
                :items="getJustificationsById"
                item-text="name"
                item-value="id"
                @change="saveJustificationId"
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
                label="Nome do Embarcador"
                class="auto-complete"
                v-model="senderId"
                :items="senders"
                item-text="name"
                item-value="id"
                @change="saveSenderId"
              />
            </v-col>
            <v-col cols="12" md="12" class="d-flex justify-end align-center">
              <v-btn
                :disabled="!hasFilters"
                elevation="2"
                color="red"
                class="mx-2"
                :dark="hasFilters"
                @click="cleanFilter()"
              >
                Limpar Filtros
              </v-btn>
              <v-btn
                :loading="loading || loadingGetAll"
                :disabled="!hasFilters"
                :dark="hasFilters"
                elevation="2"
                color="green"
                @click="search()"
              >
                Buscar
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import comboboxFormatter from '@/utils/comboboxFormatter';
import allowedChars from '@/utils/allowedChars';
export default {
  name: 'QuarantineFilters',
  props: {
    isTransfer: {
      default: false,
      type: Boolean
    },
    loadingGetAll: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    numberCTE: [],
    numberNfe: [],
    states: [],
    cities: [],
    senders: [],
    senderId: null,
    trashipmentsDeliverer: [],
    cityId: null,
    stateId: null,
    cteNumberInput: '',
    nfeNumberInput: '',
    transhipments: [],
    transhipmentId: null,
    courierId: null,
    trashipmentDelivererId: null,
    justification: null,
    couriers: [],
    justificationsList: [],
    isCouriersLoading: false,
    loading: false,
    loadingCity: false,
    loadingTranshipmentDeliverer: false
  }),
  async created() {
    this.cleanFilter();
    this.fetchSummaryDataTranshipment();
    this.fetchAllJustifications();
    this.getStates();
    this.getAllSenders();
    const couriers = await this.fetchSummaryData();
    this.couriers = couriers;
  },
  computed: {
    ...mapGetters('QuarantineStore', ['getStops']),
    ...mapGetters('NfeStore', ['getJustificationsById']),
    ...mapGetters('CouriersStore', ['getSummaryData']),
    ...mapGetters('CouriersStore', ['getCouriers']),
    ...mapGetters('AdressStore', ['getCities']),

    hasFilters() {
      if (
        this.stateId ||
        this.cityId ||
        this.transhipmentId ||
        this.trashipmentDelivererId ||
        this.courierId ||
        this.numberCTE ||
        this.numberNfe ||
        this.justification ||
        this.senderId
      ) {
        return true;
      }
      return false;
    }
  },
  methods: {
    ...mapMutations('QuarantineStore', [
      'setFilterSenderId',
      'setFilterJustificationId',
      'setFilterDirectDelivererId',
      'setFilterTranshipmentId',
      'setFilterTranshipmentDelivererId',
      'setFilterStateId',
      'setFilterCityId',
      'setFilterCteNumber',
      'setFilterNfeNumber',
      'setFilterStatusId'
    ]),
    ...mapActions('QuarantineStore', ['getManageTranshipmentDeliverersSummary']),
    ...mapActions('CouriersStore', ['fetchSummaryData']),
    ...mapActions('NfeStore', ['fetchJustificationsById']),
    ...mapActions('TranshipmentStore', ['getSummaryDataTranshipment']),
    ...mapActions('AdressStore', ['fetchStates', 'fetchCities']),
    ...mapActions('AccountsReceivableStore', ['getSenders']),

    async fetchAllJustifications() {
      try {
        const id = this.isTransfer ? 8 : 7;
        const data = await this.fetchJustificationsById(id);
        this.justificationsList = data;
      } catch (err) {
        console.error(err);
      }
    },
    async fetchSummaryDataTranshipment() {
      try {
        const data = await this.getSummaryDataTranshipment();
        this.transhipments = data;
      } catch (err) {
        console.error(err);
      }
    },
    async getStates() {
      try {
        this.states = await this.fetchStates();
      } catch (error) {
        console.error(error);
      }
    },
    async getAllSenders() {
      try {
        this.senders = await this.getSenders();
      } catch (error) {
        console.error(error);
      }
    },
    async fetchCitiesByID() {
      this.loadingCity = true;
      try {
        this.saveStateId(this.stateId);
        this.cities = await this.fetchCities(this.stateId);
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingCity = false;
      }
    },
    async fetchTranshipmentDeliverersById() {
      this.loadingTranshipmentDeliverer = true;
      try {
        this.saveTranshipmentId(this.transhipmentId);
        this.trashipmentsDeliverer = await this.getManageTranshipmentDeliverersSummary(this.transhipmentId);
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingTranshipmentDeliverer = false;
      }
    },
    search() {
      this.$emit('filterSearch');
    },
    saveJustificationId() {
      this.setFilterJustificationId(this.justification);
    },
    saveTranshipmentId() {
      this.setFilterTranshipmentId(this.transhipmentId);
    },
    saveStateId() {
      this.setFilterStateId(this.stateId);
    },
    saveCityId() {
      this.setFilterCityId(this.cityId);
    },
    filterInput(event) {
      return allowedChars(event, /[0-9,.;/]/);
    },
    saveCteNumber(value) {
      this.numberCTE = comboboxFormatter(value);
      this.setFilterCteNumber(this.numberCTE);
    },
    saveNfeNumber(value) {
      this.numberNfe = comboboxFormatter(value);
      this.setFilterNfeNumber(this.numberNfe);
    },
    saveSenderId() {
      this.setFilterSenderId(this.senderId);
    },
    saveTranshipmentDelivererId() {
      this.setFilterTranshipmentDelivererId(this.trashipmentDelivererId);
    },
    saveDirectDelivererId() {
      this.setFilterDirectDelivererId(this.courierId);
    },
    cleanFilter() {
      this.setFilterJustificationId(null);
      this.setFilterTranshipmentId(null);
      this.setFilterTranshipmentDelivererId(null);
      this.setFilterStateId(null);
      this.setFilterCityId(null);
      this.setFilterCteNumber(null);
      this.setFilterNfeNumber(null);
      this.setFilterSenderId(null);
      this.setFilterDirectDelivererId(null);
      this.clearFilterFields();
      this.$emit('filterSearch');
    },
    clearFilterFields() {
      this.transhipmentId = null;
      this.trashipmentDelivererId = null;
      this.justification = null;
      this.courierId = null;
      this.senderId = null;
      this.cityId = null;
      this.stateId = null;
      this.numberCTE = null;
      this.numberNfe = null;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep.v-select.v-select--chips .v-select__selections {
  min-height: 50px;
}
</style>
